var render = function render(){var _vm=this,_c=_vm._self._c;return _c('customer-all-select',_vm._g(_vm._b({attrs:{"supplier":true}},'customer-all-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }